import { useEffect } from "react"
import { io } from "socket.io-client"

import { useNewNotificationsRefresher, useNotificationsRefresher } from "~/domain/notification"
import { useUserInfo } from "~/domain/user-session"
import { devMode, socketApiUrl } from "~/shared/config"

/**
 * Компонент, который запускает отслеживание уведомлений после выполнения пользователем входа в систему
 * @component
 * @category Component
 */
export const TrackNewNotifications = function TrackNewNotifications() {
	const userInfo = useUserInfo()

	const refreshNotifications = useNotificationsRefresher()
	const refreshNewNotifications = useNewNotificationsRefresher()

	useEffect(() => {
		if (!userInfo) return

		const socket = io(
			devMode && socketApiUrl ? socketApiUrl : "wss://api-next.kemsu.ru",
			{
				withCredentials: true,
				path: "/socket.io/notifications"
			}
		)

		if (devMode) {
			socket.on("connect", () => {
				console.log("Начато отслеживание новых уведомлений...")
			})
		}

		socket.on("notification", async () => {
			await refreshNotifications()
			await refreshNewNotifications()
		})

		socket.on("connect_error", async (err) => {
			console.error(`connect_error due to ${err.message}`)

			setTimeout(() => socket.connect(), 1000)
			/*if (err.message === "jwt expired") {
				await userSessionStore.refreshToken()
				socket.connect()
			}*/
		})

		return () => {
			socket.off("notification")
			socket.off("connect_error")

			if (devMode) {
				socket.off("connect")
			}

			socket.disconnect()
		}

	}, [userInfo])

	return null
}
